import { useEffect } from 'react';
import { create } from 'zustand';

/**
 * The user group the open flow belongs to, when the flow itself decides it.
 *
 * A booking proposal is issued to one user group, so its flow never asks the
 * customer to pick a profile: a member lands in that group, and a non-member is
 * stopped by `ProposalAccessGate`. Global because its reader, the app-level
 * `UserGroupSelectionDialog`, sits outside the proposal's own store. Requests take
 * the proposal's group from the proposal, not from here.
 */
const useFlowUserGroupStore = create<{ userGroupId?: number; owner?: symbol }>(() => ({}));

export const useFlowUserGroupId = () => useFlowUserGroupStore((state) => state.userGroupId);

/** Registers the group for as long as the calling flow is mounted. */
export const useRegisterFlowUserGroup = (userGroupId: number | undefined) => {
  useEffect(() => {
    if (userGroupId == null) {
      return;
    }
    const owner = Symbol('flow-user-group');
    useFlowUserGroupStore.setState({ userGroupId, owner });
    return () => {
      // A flow mounted in the meantime owns the store now; leave its group in place.
      if (useFlowUserGroupStore.getState().owner === owner) {
        useFlowUserGroupStore.setState({ userGroupId: undefined, owner: undefined });
      }
    };
  }, [userGroupId]);
};
